/** @format */

import React from 'react';

export const Avatar = props => {
  return (
    <>
      <div className={`avatar-box ${props.loading ? `avatar-box-loading` : ``}`}>
        {props.srcImg !== '' ? (
          <img src={props.srcImg} alt="Avatar" />
        ) : (
          <span className="first-letter">{props.name.charAt(0)}</span>
        )}
      </div>
    </>
  );
};
